import React from 'react';
import { Helmet } from 'react-helmet-async';

const industries = [
  {
    name: 'Distributors',
    icon: '📦',
    description: 'We automate the work process',
    image: 'https://images.pexels.com/photos/4481327/pexels-photo-4481327.jpeg?auto=compress&cs=tinysrgb&w=600',
    solutions: [
      'Automated order processing',
      'Inventory management',
      'Supply chain analytics',
      'Real-time tracking',
    ],
    technologies: ['React', 'Node.js', 'IoT', 'AWS'],
  },
  {
    name: 'Real Estate',
    icon: '🏢',
    description: 'Customize the platform for sale properties',
    image: 'https://images.pexels.com/photos/439391/pexels-photo-439391.jpeg?auto=compress&cs=tinysrgb&w=600',
    solutions: [
      'Property listing platforms',
      'Virtual tours',
      'CRM for agents',
      'Online booking & payments',
    ],
    technologies: ['React', 'Node.js', 'Map APIs', 'Stripe'],
  },
  {
    name: 'Renewable Energy',
    icon: '🌞',
    description: 'Think virtual think renewable',
    image: 'https://images.pexels.com/photos/356036/pexels-photo-356036.jpeg?auto=compress&cs=tinysrgb&w=600',
    solutions: [
      'Energy monitoring dashboards',
      'IoT device integration',
      'Predictive maintenance',
      'Customer portals',
    ],
    technologies: ['React', 'Node.js', 'IoT', 'Azure'],
  },
  {
    name: 'Transportation',
    icon: '🚚',
    description: 'Automation of live tracking',
    image: 'https://images.pexels.com/photos/616966/pexels-photo-616966.jpeg?auto=compress&cs=tinysrgb&w=600',
    solutions: [
      'Fleet management systems',
      'Live GPS tracking',
      'Route optimization',
      'Driver mobile apps',
    ],
    technologies: ['React', 'Node.js', 'Map APIs', 'AWS'],
  },
  {
    name: 'Manufacture',
    icon: '🏭',
    description: 'Streamlining your production process',
    image: 'https://images.pexels.com/photos/209251/pexels-photo-209251.jpeg?auto=compress&cs=tinysrgb&w=600',
    solutions: [
      'Production line automation',
      'Inventory & supply chain',
      'Quality control dashboards',
      'IoT device integration',
    ],
    technologies: ['React', 'Node.js', 'IoT', 'Azure'],
  },
  {
    name: 'NGOs',
    icon: '🏠',
    description: 'Digital way to make life better',
    image: 'https://images.pexels.com/photos/6646916/pexels-photo-6646916.jpeg?auto=compress&cs=tinysrgb&w=600',
    solutions: [
      'Donation management systems',
      'Volunteer portals',
      'Impact reporting dashboards',
      'Event management',
    ],
    technologies: ['React', 'Node.js', 'Stripe', 'Firebase'],
  },
  {
    name: 'Restaurants & Cafe',
    icon: '☕',
    description: 'We feed your soul digitally',
    image: 'https://images.pexels.com/photos/262978/pexels-photo-262978.jpeg?auto=compress&cs=tinysrgb&w=600',
    solutions: [
      'Online ordering & delivery',
      'Reservation management',
      'POS integration',
      'Loyalty programs',
    ],
    technologies: ['React', 'Firebase', 'Stripe', 'Twilio'],
  },
  {
    name: 'Help Desk & Support',
    icon: '🖧',
    description: 'We provide reliability to your needs',
    image: 'https://images.pexels.com/photos/1181671/pexels-photo-1181671.jpeg?auto=compress&cs=tinysrgb&w=600',
    solutions: [
      'Ticketing systems',
      'Live chat integration',
      'Knowledge base portals',
      'Customer feedback tools',
    ],
    technologies: ['React', 'Node.js', 'Twilio', 'AWS'],
  },
  {
    name: 'Fintech',
    icon: '💳',
    description: 'Secure, compliant financial technology solutions for modern banking and payments.',
    image: 'https://images.pexels.com/photos/730547/pexels-photo-730547.jpeg?auto=compress&cs=tinysrgb&w=600',
    solutions: [
      'PCI DSS compliant payment systems',
      'Advanced fraud detection algorithms',
      'Secure API integrations',
      'Real-time analytics dashboards',
    ],
    technologies: ['Blockchain', 'Machine Learning', 'Microservices', 'REST APIs'],
  },
  {
    name: 'Healthcare',
    icon: '🏥',
    description: 'HIPAA-compliant healthcare technology solutions that improve patient outcomes.',
    image: 'https://images.pexels.com/photos/263402/pexels-photo-263402.jpeg?auto=compress&cs=tinysrgb&w=600',
    solutions: [
      'HIPAA-compliant cloud infrastructure',
      'Electronic Health Record (EHR) systems',
      'Secure telemedicine platforms',
      'AI-powered diagnostic tools',
    ],
    technologies: ['HL7 FHIR', 'AWS Healthcare', 'Encrypted Storage', 'AI/ML'],
  },
  {
    name: 'E-Commerce',
    icon: '🛒',
    description: 'High-performance e-commerce platforms that drive sales and customer engagement.',
    image: 'https://images.pexels.com/photos/230544/pexels-photo-230544.jpeg?auto=compress&cs=tinysrgb&w=600',
    solutions: [
      'High-performance e-commerce platforms',
      'Real-time inventory management',
      'Secure payment processing',
      'Mobile-first responsive design',
    ],
    technologies: ['React', 'Node.js', 'Stripe', 'CDN'],
  },
  {
    name: 'SaaS',
    icon: '☁️',
    description: 'Scalable SaaS solutions for modern businesses.',
    image: 'https://images.pexels.com/photos/3184360/pexels-photo-3184360.jpeg?auto=compress&cs=tinysrgb&w=600',
    solutions: [
      'Multi-tenant SaaS platforms',
      'Automated billing and subscription management',
      'API-first architecture',
      'Cloud-native scalability',
    ],
    technologies: ['Kubernetes', 'Docker', 'GraphQL', 'Azure'],
  },
  {
    name: 'Restaurants',
    icon: '🍽️',
    description: 'Modern POS, online ordering, and digital marketing for restaurants and cafes.',
    image: 'https://images.pexels.com/photos/262978/pexels-photo-262978.jpeg?auto=compress&cs=tinysrgb&w=600',
    solutions: [
      'Custom POS systems',
      'Online ordering & delivery integration',
      'Reservation management',
      'Loyalty & rewards programs',
    ],
    technologies: ['React', 'Firebase', 'Stripe', 'Twilio'],
  },
  {
    name: 'Saloons',
    icon: '💇‍♂️',
    description: 'Appointment booking, CRM, and digital presence for salons and spas.',
    image: 'https://images.pexels.com/photos/3993449/pexels-photo-3993449.jpeg?auto=compress&cs=tinysrgb&w=600',
    solutions: [
      'Online appointment scheduling',
      'Client management CRM',
      'Automated reminders',
      'Digital marketing & reviews',
    ],
    technologies: ['React', 'Node.js', 'Twilio', 'Google Calendar API'],
  },
  {
    name: 'Professional Services',
    icon: '🛠️',
    description: 'Digital solutions for service providers: field, repair, cleaning, and more.',
    image: 'https://images.pexels.com/photos/209251/pexels-photo-209251.jpeg?auto=compress&cs=tinysrgb&w=600',
    solutions: [
      'Service booking portals',
      'Job tracking & dispatch',
      'Invoicing & payments',
      'Customer feedback systems',
    ],
    technologies: ['React', 'Node.js', 'Stripe', 'Map APIs'],
  },
  {
    name: 'Lawyers & Legal',
    icon: '⚖️',
    description: 'Practice management, secure client portals, and document automation for law firms.',
    image: 'https://images.pexels.com/photos/6077326/pexels-photo-6077326.jpeg?auto=compress&cs=tinysrgb&w=600',
    solutions: [
      'Case & document management',
      'Secure client portals',
      'Appointment scheduling',
      'E-signature integration',
    ],
    technologies: ['React', 'Node.js', 'DocuSign API', 'Azure'],
  },
  {
    name: 'Smoke Shops',
    icon: '🚬',
    description: 'Custom ERP, inventory, and loyalty solutions for smoke shops and specialty retail.',
    image: 'https://images.pexels.com/photos/3586067/pexels-photo-3586067.jpeg?auto=compress&cs=tinysrgb&w=600',
    solutions: [
      'Custom ERP for inventory & compliance',
      'Age verification systems',
      'Loyalty & rewards programs',
      'Mobile POS solutions',
    ],
    technologies: ['React', 'Node.js', 'Twilio', 'Stripe'],
  },
  {
    name: 'Warehouses & Logistics',
    icon: '🏭',
    description: 'Warehouse management, inventory tracking, and logistics automation.',
    image: 'https://images.pexels.com/photos/4481327/pexels-photo-4481327.jpeg?auto=compress&cs=tinysrgb&w=600',
    solutions: [
      'Warehouse management systems (WMS)',
      'Barcode & RFID tracking',
      'Order fulfillment automation',
      'Real-time inventory dashboards',
    ],
    technologies: ['React', 'Node.js', 'IoT', 'AWS'],
  },
];

const IndustriesPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Industries | VB Entreprise | Premium IT & Digital Marketing Agency for US, UK & Canada Businesses</title>
      </Helmet>
      <div className="pt-8">
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-12 text-center">
              Industries We Serve
            </h1>
            <div className="space-y-20">
              {industries.map((industry, idx) => (
                <div key={industry.name} className={`flex flex-col lg:flex-row items-center gap-12 ${idx % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                  <div className="flex-shrink-0 w-full lg:w-1/2 flex justify-center">
                    <img
                      src={industry.image}
                      alt={industry.name}
                      className="w-full max-w-md h-72 object-cover rounded-2xl shadow-lg"
                    />
                  </div>
                  <div className="w-full lg:w-1/2">
                    <div className="flex items-center mb-4">
                      <span className="text-3xl mr-3">{industry.icon}</span>
                      <h2 className="text-3xl font-bold text-gray-900">{industry.name}</h2>
                    </div>
                    <p className="text-lg text-gray-600 mb-6">{industry.description}</p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-6">
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900 mb-2">Our Solutions:</h3>
                        <ul className="space-y-2 list-disc list-inside">
                          {industry.solutions.map((solution, i) => (
                            <li key={i} className="text-green-600">{solution}</li>
                          ))}
                        </ul>
                      </div>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900 mb-2">Key Technologies:</h3>
                        <div className="flex flex-wrap gap-2">
                          {industry.technologies.map((tech, i) => (
                            <span key={i} className="px-3 py-1 bg-blue-100 text-blue-700 text-xs rounded-full">
                              {tech}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default IndustriesPage;